let currentAudio: HTMLAudioElement | null = null;

export async function playQuestionAudio(questionId: number): Promise<void> {
  await stopAudio();
  return new Promise((resolve, reject) => {
    const audio = new Audio(`/audio/question-${questionId}.mp3`);
    currentAudio = audio;
    audio.onended = () => { currentAudio = null; resolve(); };
    audio.onerror = () => { currentAudio = null; reject(new Error('Audio playback failed')); };
    audio.play().catch(reject);
  });
}

export async function stopAudio(): Promise<void> {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
}

export function isAudioPlaying(): boolean {
  return currentAudio !== null && !currentAudio.paused;
}
